import { Route, Routes } from "react-router-dom"

import DefaultBankFlow from "./DefaultBankFlow"

const SettingsSBPFlow = () => (
  <Routes>
    <Route index element={<DefaultBankFlow />} />
  </Routes>
)

export default SettingsSBPFlow
